import type { ViewMode } from "@getregistered/greg-editors/dist/lib/GregGrid/PaginatedGridPrimer/types";

// GR-3342: the events grid remembers its card/table choice per browser, so the
// full-page reload after a bulk archive (needed for the server-rendered status
// tab counters) brings the operator back to the view they were using instead
// of the card default. Storage is a convenience only: anything that stops it
// working falls back to the server's default, never to an error.
export const VIEW_MODE_STORAGE_PREFIX = "greg.grid.view-mode.";

const VIEW_MODES: readonly ViewMode[] = ["table", "card"];

export function viewModeStorageKey(gridKey: string): string {
  return `${VIEW_MODE_STORAGE_PREFIX}${gridKey}`;
}

export function readStoredViewMode(gridKey: string, fallback: ViewMode): ViewMode {
  try {
    const stored = window.localStorage.getItem(viewModeStorageKey(gridKey));
    return (VIEW_MODES as readonly string[]).includes(stored ?? "") ? (stored as ViewMode) : fallback;
  } catch {
    return fallback;
  }
}

export function storeViewMode(gridKey: string, mode: ViewMode): void {
  try {
    window.localStorage.setItem(viewModeStorageKey(gridKey), mode);
  } catch {
    // Private windows and blocked storage: the choice just does not persist.
  }
}
